export const headersConfig = [
  {
    key: "name",
    label: "services.process.colum.name"
  },
  {
    key: "pid",
    label: "services.process.colum.id"
  },
  {
    key: "parent_pid",
    label: "services.process.colum.parent"
  },
  {
    key: "children_number",
    label: "services.process.colum.children"
  },
  {
    key: "status",
    label: "services.process.colum.stat"
  },
  {
    key: "cpu_percent",
    label: "services.process.colum.cpu"
  },
  {
    key: "rss",
    label: "services.process.colum.mem"
  },
  {
    key: "username",
    label: "services.process.colum.user"
  },
  {
    key: "create_time",
    label: "services.process.colum.run"
  }
] as const;

export type HeadersKeys = (typeof headersConfig)[number]["key"];
